import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_jcguize.png'


const _hoisted_1 = { class: "ttsPage" }
const _hoisted_2 = { class: "ttsOff" }
const _hoisted_3 = { class: "ttsOn" }
const _hoisted_4 = { class: "ttsOnInner" }
const _hoisted_5 = { class: "ttsOnDown" }

import { ref, onMounted,watch } from 'vue'
import ttsSel from './ttsSel.vue'
import ttsDown from './ttsDown.vue'
import { useRouter ,useRoute} from 'vue-router';
import {captionTtsStore} from "@/store/captionTts.ts"

export default /*@__PURE__*/_defineComponent({
  __name: 'ttsPage',
  emits: ['openttsDown'],
  setup(__props, { expose: __expose, emit: __emit }) {

const route=useRoute()
const ttstore=captionTtsStore()
//参数
const ttsOnOff=ref(false)
const ttsSelShow=ref(false)
const ttsDownShow=ref(false)


watch(route, (to, from) => {
    ttsSelShow.value=false
    ttsDownShow.value=false
    ttsOnOff.value=ttstore.isOpen
})
const isOpen=(data:any)=>{
    ttsOnOff.value=data
}
let emit=__emit
// 幻音弹窗
const openttsSel=()=>{
    ttsSelShow.value=!ttsSelShow.value
    ttsDownShow.value=false
}

const onInputFun=(data:any)=>{
    emit('openttsDown',data)
}
const closeMenu=()=>{
    ttsSelShow.value=false
    ttsDownShow.value=false
} 
const ttsDownShowFun=()=>{
    ttsDownShow.value=true
    ttsSelShow.value=false
} 
 
__expose({
    closeMenu,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "ttsOffInner",
        onClick: _withModifiers(openttsSel, ["stop"])
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "ttsOffLeft" }, "幻音", -1),
        _createElementVNode("span", { class: "ttsOffRight" }, "OFF", -1)
      ]))
    ], 512), [
      [_vShow, !ttsOnOff.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "ttsOnBtn",
          onClick: _withModifiers(openttsSel, ["stop"])
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "ttsOnLeft" }, "幻音", -1),
          _createElementVNode("span", { class: "ttsOnRight" }, "ON", -1)
        ])),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: _withModifiers(ttsDownShowFun, ["stop"])
          })
        ])
      ])
    ], 512), [
      [_vShow, ttsOnOff.value]
    ]),
    (ttsSelShow.value)
      ? (_openBlock(), _createBlock(ttsSel, {
          key: 0,
          class: "ttsSelStyle",
          onIsOpen: isOpen,
          onCloseThis: _cache[0] || (_cache[0] = ($event: any) => (ttsSelShow.value=false))
        }))
      : _createCommentVNode("", true),
    (ttsDownShow.value)
      ? (_openBlock(), _createBlock(ttsDown, {
          key: 1,
          class: "ttsDownStyle",
          onOnInputFun: onInputFun,
          onCloseDown: _cache[1] || (_cache[1] = ($event: any) => (ttsDownShow.value=false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})